// extracted by mini-css-extract-plugin
export default {"dragger":"ResizableDrawer_dragger__QNCl+","maxWidth":"ResizableDrawer_maxWidth__AUjnK"};